import { render } from "./DocumentView.vue?vue&type=template&id=393a3306&ts=true"
import script from "./DocumentView.vue?vue&type=script&lang=ts"
export * from "./DocumentView.vue?vue&type=script&lang=ts"

import "./DocumentView.vue?vue&type=style&index=0&id=393a3306&lang=css"

import exportComponent from "D:\\Development\\Casa\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__